// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2V9Bf","title":"ClientCherryInfo_title__17M-m","itemText":"ClientCherryInfo_itemText__2sizT"};